import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { resetScroll } from 'src/utils/smoothScroll';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    resetScroll();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
